export const $regraEntidade = {
  menuLateral: {
    empresas: {
      buscar: 'MENU_LATERAL_EMPRESAS_BUSCAR',
      cadastrarNova: 'MENU_LATERAL_EMPRESAS_CADASTRAR_NOVA'
    },
    header: {
      configuracoes: 'MENU_LATERAL_HEADER_CONFIGURACOES',
      empresas: 'MENU_LATERAL_HEADER_EMPRESAS',
      meusProdutos: 'MENU_LATERAL_HEADER_MEUS_PRODUTOS',
      produtos: 'MENU_LATERAL_HEADER_PRODUTOS',
    },
    inicio: 'MENU_LATERAL_INICIO',
    portalUsuariosSesi: 'MENU_LATERAL_PORTAL_USUARIOS_SESI',
    meusProdutosOutrosProdutos: 'MENU_LATERAL_MEUS_PRODUTOS_OUTROS_PRODUTOS',
    geralOutrosProdutos: 'MENU_LATERAL_GERAL_OUTROS_PRODUTOS',
    meusProdutosPowerBI: {
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_POWER_BI_PAINEL',
    },
    meusProdutosSesiFit: {
      painel: 'MENU_LATERAL_PRODUTOS_SESI_FIT_PAINEL',
    },
    meusProdutosSesiFitSesi: {
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_SESI_FIT_PAINEL',
    },
    meusProdutosAcademias:{
      painel: 'MENU_LATERAL_PRODUTOS_ACADEMIAS_COMPANY_PAINEL',
    },
    meusProdutosAcademiasSesi:{
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_ACADEMIAS_COMPANY_PAINEL',
    },
    meusProdutosPaineis:{
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_PAINEIS_PAINEL',
    },
    meusProdutosFisioterapia: {
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_FISIOTERAPIA_PAINEL',
    },
    meusProdutosGinasticaLaboral: {
      painel: 'MENU_LATERAL_MEUS_PRODUTOS_GINASTICA_LABORAL_PAINEL_BI'
    },
    produtos: {
      painel: 'MENU_LATERAL_PRODUTOS_PAINEL',
    },
    produtoFisioterapia:{
      painel: 'MENU_LATERAL_PRODUTOS_FISIOTERAPIA_PAINEL'
    },
    produtoPaineis: {
      painel: 'MENU_LATERAL_PRODUTOS_PAINEIS_PAINEL',
    },
    produtoGinasticaLaboral: {
      painel: 'MENU_LATERAL_PRODUTOS_GINASTICA_LABORAL_PAINEL_BI',
    },
    modulos: {
      modulo: 'MENU_LATERAL_MODULOS',
    },
    relatorios: {
      relatorio: 'MENU_LATERAL_MODULOS',
    }
  },
  menuSuperior: {
    ajudaESuporte: 'MENU_SUPERIOR_AJUDA_E_SUPORTE',
    minhaConta: 'MENU_SUPERIOR_MINHA_CONTA',
    politicaDePrivacidade: 'MENU_SUPERIOR_POLITICA_DE_PRIVACIDADE',
    notificacoes: 'MENU_SUPERIOR_NOTIFICACOES'
  },
  perfil: {
    ajudaESuporte: 'PORTAL_AJUDA_E_SUPORTE',
    politicaDePrivacidade: 'PORTAL_POLITICA_DE_PRIVACIDADE'
  },
  portal: {
    buscar: 'PORTAL_BUSCAR',
    cadastrarNova: 'PORTAL_CADASTRAR_NOVA',
    faq: {
      admin: 'PORTAL_FAQ_ADMIN',
      empresa: 'PORTAL_FAQ_EMPRESA'
    },
    grupo: {
      filial: 'PORTAL_GRUPO_FILIAL',
      matriz: 'PORTAL_GRUPO_MATRIZ',
      parametros: 'PORTAL_GRUPO_PARAMETROS',
      pessoas: 'PORTAL_GRUPO_PESSOAS',
      modulos: 'PORTAL_GRUPO_MODULOS'
    },
    inicio: {
      acessoGeral: 'PORTAL_INICIO',
      sesi: 'PORTAL_INICIO_SESI',
      empresa: 'PORTAL_INICIO_EMPRESA'
    },
    usuariosSesi: 'PORTAL_USUARIOS_SESI',
    usuarioEmpresa:{
      saude:'PORTAL_EMPRESAS_DETALHES_SAUDE'
    },
    ajudaESuporte: {
      topico: 'PORTAL_TOPICOS_AJUDA_SUPORTE',
      categoria: 'PORTAL_CATEGORIAS_AJUDA_SUPORTE'
    },
    outrosProdutos: {
      empresa: 'PORTAL_OUTROS_PRODUTOS_EMPRESA',
      sesi: 'PORTAL_OUTROS_PRODUTOS_SESI'
    },
    modulos:{
      modulo: 'MENU_LATERAL_MODULOS',
    },
    relatorios:{
      relatorio: 'PORTAL_MODULOS',
    }
  },
  rotas: {
    autenticacao: 'AUTH',
    protegida: 'ACL',
        publica: 'PUBLIC',
  }
}

export const $regraAcao = {
  atualizar: 'ATUALIZAR',
  inserir: 'INSERIR',
  remover: 'REMOVER',
  visualizar: 'VISUALIZAR',
  exportar: 'EXPORTAR',
}
